import { render, staticRenderFns } from "./CallHistory.vue?vue&type=template&id=544ba351&scoped=true&"
import script from "./CallHistory.vue?vue&type=script&lang=js&"
export * from "./CallHistory.vue?vue&type=script&lang=js&"
import style0 from "./CallHistory.vue?vue&type=style&index=0&id=544ba351&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544ba351",
  null
  
)

component.options.__file = "CallHistory.vue"
export default component.exports